import {
  type ThemeOptions,
  createTheme as createMuiTheme,
} from '@mui/material';

export const createTheme = (props: ThemeOptions) =>
  createMuiTheme({
    ...props,
    components: {
      ...props.components,
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
  });

export type { Theme, ThemeOptions } from '@mui/material/styles/createTheme';
